export * from './informe-de-pagamento.component';
